//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'MASCC',
  data() {
    return {
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        item7: '',
      },
      item7List: [
        { value: '5', name: '没有或轻度症状' },
        { value: '3', name: '中度症状' },
        { value: '0', name: '重度症状' },
      ],
      hasScore: false,
      disabled: false,
      title: '',
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = form.item1 * 2 + form.item2 * 3 + form.item3 * 3 + form.item4 * 4 + form.item5 * 4 + form.item6 * 5 + form.item7 * 1
        if (res < 21) {
          self.text = '并发症风险较高,建议住院接受经验性静脉抗菌药物治疗,通常需要延长住院时间'
        } else {
          self.text = '并发症风险较低,可在门诊或住院接受口服或静脉注射经验性抗菌药物治疗'
        }
        self.hasScore = true
        return String(res)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/MASCC.vue